import React from "react";
import {
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Switch } from "antd";
import styles from "./style.module.scss";
import { Button } from "antd";
import samplesec from "../../assets/images/samplesec.png";
import SpiceSelect from "./spiceSelect";
import EditCard from "./editCard";

const SectionCard = (props) => {
  const {
    onAddItem,
    menuItem,
    setExpandId,
    expandId,
    onDeleteItem,
    onDeleteGroup,
    onEditItem,
    onEditGroup,
    secEdit,
    setSecEdit,
    onUpdateGroup,
    settingsList
  } = props;
  const showExpand = () => {
    if(expandId.indexOf(menuItem.id) > -1){
      const currentIds = [...expandId];
      currentIds.splice(expandId.indexOf(menuItem.id), 1);
      setExpandId(currentIds);
    } else {
      const currentIds = [...expandId];
      currentIds.push(menuItem.id);
      setExpandId(currentIds);
    }
  };
  return (
    <div className={styles.card_wrap}>
      {secEdit.id === menuItem.id ? (
        <EditCard
          secEdit={secEdit}
          setSecEdit={setSecEdit}
          onUpdateGroup={onUpdateGroup}
        />
      ) : (
        <div
          className={styles.head_card}
          onClick={() => showExpand()}
        >
          <div className={styles.img_sec}>
            <div className={styles.sec_imgholder}>
              <img
                src={menuItem.photo_url || samplesec}
                style={{ height: "inherit", width: "inherit" }}
                alt=""
              />
            </div>
            <span className={styles.sec_name}>{menuItem.name}</span>
            {expandId.indexOf(menuItem.id) == -1 ? (
              <UpOutlined
              />
            ) : (
              <DownOutlined
              />
            )}
          </div>
          <div
            className={styles.action_sec}
            onClick={(e) => e.stopPropagation()}
          >
            <Button
              danger
              onClick={() => {
                onAddItem(menuItem);
              }}
            >
              Add Item
            </Button>
            <EditOutlined
              className={styles.edit}
              onClick={() => {
                onEditGroup(menuItem);
              }}
            />
            <DeleteOutlined
              className={styles.delete}
              onClick={() => {
                onDeleteGroup(menuItem.id);
              }}
            />
          </div>
        </div>
      )}
      {expandId.indexOf(menuItem.id) < 0 && (
        <div className={styles.sec_content}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr className={styles.content_row}>
                <th className="">Name</th>
                {settingsList.allow_description && <th>Description</th>}
                <th>Price</th>
                {(settingsList.allow_gluten_free || settingsList.allow_vegan || settingsList.allow_vegetarian ) && <th>GF/VT/V</th>}
                {/* {settingsList.allow_spice_level && <th>Spicy</th>} */}
                {settingsList.allow_calories && <th>Calories</th>}
                <th>--</th>
                <th> </th>
              </tr>
            </thead>
            {menuItem?.menu_items?.map((subItems) => {
              return (
                <tr className={styles.content_list}>
                  <td>
                    <div className={styles.content_one}>
                      {/* <img src={samplesec} style={{height: '60px'}} alt="" /> */}
                      <div style={{ width: 60, height: 60, marginRight: 5 }}>
                        <img
                          src={subItems.photo_url}
                          style={{ width: "inherit", height: "inherit" }}
                          alt=""
                        />
                      </div>
                      <div> {subItems.name}</div>
                    </div>
                  </td>
                  {settingsList.allow_description && <td>
                    <div className={styles.content_desc}>
                      {subItems.description}
                    </div>
                  </td>}
                  <td>
                    <div className={styles.content_price}>
                      $ {subItems.price}
                    </div>
                  </td>
                  { (settingsList.allow_gluten_free || settingsList.allow_vegan || settingsList.allow_vegetarian ) && <td>
                    <div className={styles.content_four}>
                      {subItems.is_gluten_free && settingsList.allow_gluten_free &&(
                        <div className={styles.circle_tag}>GF</div>
                      )}
                      {subItems.is_vegetarian && settingsList.allow_vegetarian && (
                        <div
                          className={styles.circle_tag}
                          style={{ backgroundColor: "#9FEC92" }}
                        >
                          VT
                        </div>
                      )}
                      {subItems.is_vegan && settingsList.allow_vegan && (
                        <div
                          className={styles.circle_tag}
                          style={{ backgroundColor: "#04540C" }}
                        >
                          V
                        </div>
                      )}
                    </div>
                  </td>}
                  {/* {settingsList.allow_spice_level && <td>
                    <div className={styles.content}>
                      {SpiceSelect("", subItems.spice_level)}
                    </div>
                  </td>} */}
                  {settingsList.allow_calories && <td>{subItems.calories || '-'}</td>}
                  <td>
                    <div className={styles.content}>
                      <Switch defaultChecked />
                    </div>
                  </td>
                  <td>
                    <div className={styles.content_actions}>
                      <EditOutlined
                        onClick={() => {
                          onEditItem(subItems, menuItem);
                        }}
                      />
                      <DeleteOutlined
                        style={{ color: "#FF4D4FD9" }}
                        onClick={() => {
                          onDeleteItem(subItems.id);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      )}
    </div>
  );
};
export default SectionCard;
